import React from "react";

export default function SgcFiltrosHeader({ onCollapse }) {
  return (
    <div className="sgc-filtros-head">
      <div className="sgc-filtros-head__main">
        <div className="sgc-filtros-title">Filtros</div>
        {onCollapse ? (
          <button
            type="button"
            className="sgc-filtros-toggle"
            onClick={onCollapse}
            aria-label="Ocultar filtros"
            data-sgc-tooltip="Ocultar filtros"
            data-sgc-tooltip-pos="left"
          >
            <i className="bi bi-chevron-right" aria-hidden />
          </button>
        ) : null}
      </div>
      <div className="sgc-filtros-head__divider" aria-hidden />
    </div>
  );
}
